export enum VideoPlaybackState {
    Started,
    Playing
}